import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface ActivityLogEntityTypeOption {
  value: string;
  label: string;
  apiControllerRoute: string;
}

@Injectable({
  providedIn: 'root',
})
export class ActivityTrackerService {
  constructor(private http: HttpClient) {}

  /** Entity types the current user can read, for the filter dropdown and row-link routing. */
  async getEntityTypeOptions(): Promise<ActivityLogEntityTypeOption[]> {
    return await firstValueFrom(
      this.http.get<ActivityLogEntityTypeOption[]>('/api/activity-logs/entity-types'),
    );
  }
}
